<template>
    <v-dialog v-model="dialog" content-class="modal-dialog">
        <v-card class="modal-heating-history">
            <div class="common-text mb-2">
                История отопителя
            </div>
            <v-layout column ma-0 class="main-text mb-5 w-100 heating-list scrollbar-block">
                <v-flex xs12 class="text-center grey-text" v-if="heatingHistory.length == 0">
                     Нет доступной истории
                </v-flex>
                <v-flex v-else xs12 v-for="(action, index) in heatingHistory" :key="index" class="heatings">
                    <v-layout v-if="action.new_day" class="heatings__title bold-text">
                        {{action.new_day}}
                    </v-layout>
                    <v-flex class="heating-row" v-if="action.state">
                        <div class="d-inline-flex mr-3" v-if="action.state.heating">
                            <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_icon.svg')" class="d-inline-flex"/>
                        </div>
                        <div class="d-inline-flex mr-3" v-else>
                            <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_disabled_icon.svg')" class="d-inline-flex"/>
                        </div>
                        <div class="d-inline-flex">
                            время: {{action.start_updated}}
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-flex class="d-flex w-100 justify-end mt-6">
                <v-btn class="btn-grey main-text" @click="close">
                    Закрыть
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import {getTimeFromDate} from "@/utils";
import { timeWithTZ } from '@/utils/index';

export default {
    name: "ModalHeatingHistory",
    props: {
        value: {
            type: Boolean,
        },
        history: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            dialog: false,
            heatingHistory: [],
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('input', false);
            }
        },
        history(val) {
            if (val) {
                this.setHeatingHistory();
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        setHeatingHistory() {
            this.heatingHistory = JSON.parse(JSON.stringify(this.history));
            this.heatingHistory.forEach((heating, index) => {
                heating.start_updated = getTimeFromDate(heating.date);
                if (index > 0) {
                    if (this.checkDay(heating.date) != this.checkDay(this.heatingHistory[index - 1].date)) {
                        heating.new_day = this.checkDay(heating.date);
                        heating.new_day = this.reverseDate(heating.new_day);
                    }
                } else {
                    heating.new_day = this.checkDay(heating.date);
                    heating.new_day = this.reverseDate(heating.new_day);
                }
            });
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-heating-history.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .heating-list {
        min-height: 400px;
        max-height: 60vh;
        overflow-y: auto;
    }

    .heatings {
        &:not(:last-child) {
            border-bottom: 1px solid #787878;
        }

        &__title {
            margin: 10px 0;
            background: #ffd9b3;
            justify-content: center;
            border-radius: 30px;
        }

        .heating-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            min-height: 38px;

            &:not(:last-child) {
                border-bottom: 1px solid #787878;
            }

            .v-image{
                max-height: 32px;
                max-width: 32px;
            }
        }
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>